import styled from 'styled-components';

import { Button } from '@xing-com/button';
import type { ButtonSizes } from '@xing-com/button';
import { mediaTopBarHidden, mediaTopBarVisible } from '@xing-com/layout-tokens';
import { scale030, spaceXS } from '@xing-com/tokens';

import { StyledMarker } from '../header/header.styled';

type ButtonSmallWhenTopBarProps = {
  $size: ButtonSizes;
};

const pickMediaQuery = ({ $size }: ButtonSmallWhenTopBarProps): string => {
  return $size === 'small' ? mediaTopBarHidden : mediaTopBarVisible;
};

export const ButtonSmallWhenTopBar = styled(Button)<ButtonSmallWhenTopBarProps>`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${pickMediaQuery} {
    display: none;
  }
`;

export const CreateJobMarker = styled(StyledMarker)<ButtonSmallWhenTopBarProps>`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${mediaTopBarVisible} {
    bottom: calc(-1 * ${scale030});
    padding-inline: ${spaceXS};
  }

  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${pickMediaQuery} {
    display: none;
  }
`;
